import { FC, memo } from 'react'
import { Button, Tooltip } from '@blueprintjs/core'
import { usePdfEditor } from './PdfEditorProvider'
import useCallbackDebounced from '../../../hooks/shared/useCallbackDebounced'

const ChangeImageContextMenuButton: FC = () => {
  const { filePickerRef } = usePdfEditor()
  const handleChangeImageClicked = useCallbackDebounced(() => {
    filePickerRef.current?.click()
  }, [filePickerRef])
  return (
    <Tooltip content={'Choose different image'} placement="bottom">
      <Button intent="none" variant="minimal" icon="media" onClick={handleChangeImageClicked} />
    </Tooltip>
  )
}

export default memo(ChangeImageContextMenuButton)
